import { gettext } from '@eventbrite/i18n';
import { Typography, TypographyProps } from '@eventbrite/marmalade';
import React from 'react';

import { Icon } from '@eventbrite/eds-icon';
import { HelpChunky } from '@eventbrite/eds-iconography';
import { withTooltip } from '@eventbrite/eds-tooltip';

import './EventCardPromoted.scss';

interface EventCardPromotedProps extends Omit<TypographyProps, 'children'> {
    isPromoted?: boolean;
    tokens?: EventCardPromotedTokens;
}

interface EventCardPromotedTokens {
    '--PromotedPaddingBottom'?: string;
}

const EventCardPromotedBase: React.FunctionComponent<EventCardPromotedProps> = (
    props,
) => {
    const { isPromoted, tokens, ...typographyProps } = props;

    if (!isPromoted) {
        return null;
    }

    const IconWithTooltip = withTooltip(Icon);

    return (
        <div
            className="event-card-promoted"
            style={tokens as React.CSSProperties}
        >
            <Typography
                variant="body-sm"
                color="neutral-600"
                {...typographyProps}
            >
                {gettext('Promoted')}
            </Typography>
            <span>
                <IconWithTooltip
                    type={<HelpChunky fill="#6f7287" />}
                    size="xsmall"
                    tooltipId="tooltip-info"
                    tooltipStyle="phab"
                    wrapperComponent="span"
                    tooltipText={
                        <Typography variant="body-sm">
                            {gettext(
                                'Business owners and event organizers paid for these ads.',
                            )}
                        </Typography>
                    }
                    tooltipArrowLocation="left"
                />
            </span>
        </div>
    );
};

//Memoize result to prevent needing to re-render
//withTooltip every instance unless necessary.
export const EventCardPromoted = React.memo(
    EventCardPromotedBase,
    (prevProps, nextProps) => prevProps.isPromoted === nextProps.isPromoted,
);
